import styled from 'styled-components';

export const TrustGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 12px;
  margin: 16px 0;
  padding: 4px 10px 8px;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 12%);
  background-color: #fff;
  cursor: pointer;

  & span {
    font-size: 13px;
    color: hsl(0deg 0% 0% / 87%);
    padding-left: 6px;
  }
`;

export const ReturnPopupDiv = styled.div`
  opacity: 0.8;
  font-size: 16px;
  color: #000;
  border-bottom: 1px solid #ccc;
  font-weight: bold;
  padding: 12px 16px 9px;
  text-align: left;
`;

export const ReturnPopupSubDiv = styled.div`
  opacity: 0.87;
  font-size: 16px;
  color: #000;
  padding: 10px 16px;
  text-align: left;
`;

export const PopupBottomImg = styled.img`
  width: 100%;
  height: auto;
  padding: 10px;
  max-width: 400px;
`;

export const ModalCrossbtn = styled.img`
  width: 20px;
  height: 20px;
  position: absolute;
  top: 8px;
  right: 10px;
  z-index: 9;
  background-size: cover;
  @media (min-width: 720px) {
    cursor: pointer;
  }
`;
